import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Grid } from "@mui/material";
import { Link } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

function Years() {
  const [items, setItems] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(20);
  const [pagination, setPagination] = useState({});
  const [notification, setNotification] = useState({ open: false, color: "success", message: "" });

  const showMessage = (message, color = "success") => {
    setNotification({ open: true, color, message });
    setTimeout(() => setNotification({ open: false, color, message: "" }), 2500);
  };

  const loadYears = async (page = pageNo, currentLimit = limit) => {
    if (init() !== "success") {
      return;
    }

    try {
      const resp = await axios.get(`${Constants.getUrls.getAllYears}?page=${page}&limit=${currentLimit}`);
      setItems(resp?.data?.data?.docs || []);
      setPagination(resp?.data?.data || {});
      setPageNo(resp?.data?.data?.page || page);
      setLimit(resp?.data?.data?.limit || currentLimit);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to load years.", "error");
    }
  };

  useEffect(() => {
    loadYears(1, limit);
  }, []);

  const handleDelete = async (id) => {
    try {
      const resp = await axios.delete(`${Constants.deleteUrls.deleteYear}${id}`);
      showMessage(resp?.data?.message || "Year deleted successfully.");
      loadYears(pageNo, limit);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to delete year.", "error");
    }
  };

  const rows = items.map((item, index) => ({
    serial: (pageNo - 1) * limit + index + 1,
    year: item?.year || "-",
    status: (
      <span style={{ color: item?.status === "active" ? "#16a34a" : "#f59e0b", fontWeight: 700 }}>
        {item?.status || "inactive"}
      </span>
    ),
    action: (
      <MDBox display="flex" gap={1}>
        <Link to={`/updateyear/${item._id}`}>
          <MDButton variant="outlined" size="small" color="info">
            Update
          </MDButton>
        </Link>
        <MDButton variant="outlined" size="small" color="error" onClick={() => handleDelete(item._id)}>
          Delete
        </MDButton>
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
            <MDTypography variant="h6" color="white">
              Years
            </MDTypography>
          </MDBox>
          <Grid item sm={4} px={2} py={2} align="right">
            <Link to="/addyear">
              <MDButton variant="contained" size="small" color="primary">
                Create Year
              </MDButton>
            </Link>
          </Grid>
          <MDBox>
            <DataTable
              table={{
                columns: [
                  { Header: "serial", accessor: "serial", width: "8%" },
                  { Header: "Year", accessor: "year" },
                  { Header: "Status", accessor: "status" },
                  { Header: "Action", accessor: "action" },
                ],
                rows,
              }}
              entriesPerPage={{ defaultValue: limit, entries: [10, 25, 50, 100] }}
              page_no={pagination?.page}
              totalPages={pagination?.totalPages}
              hasNextPage={pagination?.hasNextPage}
              hasPrevPage={pagination?.hasPrevPage}
              isnextPage={pagination?.nextPage}
              prevPage={pagination?.prevPage}
              totalDocs={pagination?.totalDocs}
              onPageChange={(page) => loadYears(page, limit)}
              onEntriesPerPageChange={(newLimit) => loadYears(1, newLimit)}
            />
          </MDBox>
          <MDSnackbar
            color={notification.color}
            icon="notifications"
            title="AgriQuiz"
            content={notification.message}
            dateTime="Just now"
            open={notification.open}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default Years;
